module.exports = __webpack_public_path__ + "img/cass2.a8fe408a.jpg";